// File: `app/javascript/controllers/product_module/bicicleta.js`
import $ from 'jquery';
import flatpickr from 'flatpickr';
import {withElementBlock} from "../blockUI_controller";

export function initBicicleta(deps = {}) {
    const {
        form_type_send,
        create_array_for_product,
        create_id_for_product,
        service_by_dealer,
        get_contract,
        modality_info,
        setSessionVar,
        showDescriptionModal,
        date_disabled,
        flatpick_lang,
        I18n,
        location,
        sessionStorage
    } = deps;

    if (!form_type_send) return;

    // Selectores
    let bicicleta_to = $('#bicicleta_to');
    let bicicleta_date = $('#bicicleta_date');
    let bicicleta_type = $('#bicicleta_type');
    let bicicleta_modality = $('#bicicleta_modality');
    let bicicleta_cantidad_block = $('#bicicleta_cantidad_block');
    let bicicleta_cantidad = $('#bicicleta_cantidad');
    let bicicleta_btn_info = $('#bicicleta_btn_info');
    let bicicleta_btn_info_desc = '';

    bicicleta_date.prop('disabled', true);
    bicicleta_type.prop('disabled', true).select2({ theme: 'bootstrap' });
    bicicleta_modality.prop('disabled', true).select2({
        theme: 'bootstrap',
        placeholder: I18n.t('global.main.form.select_modality')
    });

    bicicleta_to.select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_destiny'),
        ajax: {
            url: `${location.origin}/${sessionStorage.getItem('locale')}/destination`,
            dataType: "json",
            language: "es",
            data: function (params) {
                return {
                    form_type: form_type_send.val(),
                    search: params.term,
                    page: params.page || 1
                }
            },
            type: 'GET',
            processResults: function (data, params) {
                let result = [];
                params.page = params.page || 1;
                (data.rows || []).forEach(elem => {
                    result.push({
                        id: `${elem.code}|${elem.id}|${elem.name}`,
                        text: elem.name
                    });
                });
                const total = data.total || 0;
                return {
                    results: result,
                    pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                };
            }
        }
    }).on('change', function (e) {
        const parts = (e.target.value || '').split("|");
        const data_bicicleta_to = parts[1];

        create_array_for_product('product_type', form_type_send.val());
        create_array_for_product('destination_id', parts[1]);
        create_array_for_product('destination_code', parts[0]);
        create_array_for_product('text_destination', parts[2]);

        bicicleta_type.empty();
        bicicleta_modality.empty();
        bicicleta_date.val('');
        $('#excursion_location').val('');
        $('#excursion_lang').empty();
        bicicleta_btn_info[0].classList.add('ocultar');
        bicicleta_btn_info_desc = '';

        // FIX (2026-08-10): bloquear el formulario mientras service_by_dealer carga.
        withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
            service_by_dealer(data_bicicleta_to, form_type_send),
            { timeout: 30000 }
        ).then(sbd => {
            let result = [];
            (sbd.services || []).forEach(elem => {
                result.push({
                    id: `${elem.id}|${elem.code}|${elem.reservation_time}|${sbd.dealer_code}|${sbd.dealer_name}|${sbd.dealer_id}|${elem.min_reservation_amount}|${elem.max_reservation_amount}`,
                    text: elem.name
                });
            });

            bicicleta_modality.empty();
            bicicleta_cantidad_block[0].classList.add('ocultar');
            bicicleta_btn_info[0].classList.add('ocultar');
            bicicleta_btn_info_desc = '';

            if (!result.length) return;

            let product_type = result[0].id.split("|");
            let product_name = (e.target.selectedOptions && e.target.selectedOptions[0] && e.target.selectedOptions[0].innerHTML || '').toLowerCase();

            // mostrar campos de excursion
            $('#excursion_location_container')[0].classList.remove('ocultar');
            $('#excursion_location')[0].classList.add('required');
            $('#excursion_lang_container')[0].classList.remove('ocultar');
            $('#excursion_lang')[0].classList.add('required');

            create_array_for_product('category_id', product_type[0]);
            create_array_for_product('category_code', product_type[1]);
            create_array_for_product('dealer_code', product_type[3]);
            create_array_for_product('dealer_name', product_type[4]);
            create_array_for_product('dealer_id', product_type[5]);

            // FIX (2026-08-10): contrato con bloqueo + desbloqueo garantizado.
            withElementBlock('box-form', I18n.t('global.main.form.message.search_contract'), get_contract('box-form')).then(gcontract => {
                if (!gcontract.next) return;
            });

            bicicleta_date.prop('disabled', false);

            // Modalidades
            let modality_selected = '';
            bicicleta_modality.prop('disabled', false).select2({
                theme: "bootstrap",
                placeholder: I18n.t('global.main.form.select_modality'),
                ajax: {
                    url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities`,
                    dataType: "json",
                    language: "es",
                    data: function (params) {
                        return {
                            search: params.term,
                            product: product_type[0],
                            dealer: product_type[5]
                        }
                    },
                    type: 'GET',
                    processResults: function (data, params) {
                        let result = [];
                        (data.rows || []).forEach(elem => {
                            result.push({ id: elem, text: elem });
                        });
                        return { results: result };
                    }
                }
            }).on('change', function (e) {
                modality_selected = e.target.value;

                bicicleta_cantidad.prop('disabled', false);
                bicicleta_btn_info[0].classList.add('ocultar');
                bicicleta_btn_info_desc = '';

                create_array_for_product('modalities_name', e.target.value);

                bicicleta_cantidad_block[0].classList.remove('ocultar');
                bicicleta_cantidad[0].setAttribute('data-min', product_type[6]);
                bicicleta_cantidad[0].setAttribute('data-max', product_type[7]);

                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    modality_info(product_type[5], product_type[0], modality_selected),
                    { timeout: 30000 }
                ).then(modality => {
                    create_array_for_product('calc_amount', modality.calc_amount);
                    if (modality.info === 'true') {
                        create_array_for_product('day_min_rent', modality.min);
                        create_array_for_product('day_max_rent', modality.max);
                        if (modality.description !== '') {
                            bicicleta_btn_info[0].classList.remove('ocultar');
                            bicicleta_btn_info_desc = modality.description;
                        }
                    }
                });
            });

            // Cantidad -> generar id y ajustar pax/amount
            bicicleta_cantidad.off('change').on('change', function (e) {
                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    modality_info(product_type[5], product_type[0], modality_selected),
                    { timeout: 30000 }
                ).then(modality_by_cant => {
                    // FIX (2026-08-10): guard contra el valor neutro de modality_info (data: null en error).
                    if (!modality_by_cant || !modality_by_cant.data || !modality_by_cant.data[0]) return;
                    create_array_for_product('modality_code', modality_by_cant.data[0].code);
                    if (modality_by_cant.description !== '') {
                        bicicleta_btn_info[0].classList.remove('ocultar');
                        bicicleta_btn_info_desc = modality_by_cant.description;
                    }
                    create_array_for_product('pax', e.target.value);
                    create_array_for_product('amount', e.target.value);

                    create_id_for_product(product_type[0], product_type[3], product_type[1], modality_by_cant.data[0].code, e.target.value).then();
                });
            });

            // Calendario
            flatpickr(bicicleta_date, {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                disable: date_disabled,
                minDate: new Date().fp_incr(parseInt(product_type[2] || 0)),
                maxDate: new Date().fp_incr(90),
                locale: flatpick_lang
            });

            bicicleta_date.off('change').on('change', function (e) {
                setSessionVar('from_date', e.target.value, 'add', true, false).then(from => {
                    create_array_for_product('from_date', from.value);
                });
                setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(to => {
                    create_array_for_product('to_date', to.value);
                });
            });

            bicicleta_btn_info.off('click').on('click', function () {
                showDescriptionModal(`Descripción de ${create_array_for_product('modalities_name', '', 'show')}`, bicicleta_btn_info_desc);
            });
        });
    });
}
